export const equityInvestEtcData = {}
